import script from "./ToggleComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ToggleComponent.vue?vue&type=script&setup=true&lang=js"

import "./ToggleComponent.vue?vue&type=style&index=0&id=7fee5b6e&scoped=true&lang=css"

import exportComponent from "/home/viction/eshopcommand/source/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fee5b6e"]])

export default __exports__